<script setup>
  defineProps({
    fullWidth: {
      type: Boolean,
      default: false
    }
  });
</script>
<template>
  <div
    class="w-full max-w-6xl flex-1 p-4 sm:p-6 transition-all duration-1000"
    :class="{ 'max-w-full !p-0': fullWidth }"
  >
    <slot />
  </div>
</template>
